import { buildGtmScript } from './gtm-scripts';

/** Site + global GTM containers registered with the CMP. */
const gtmScripts = [
  buildGtmScript(
    process.env.NEXT_PUBLIC_GTM_ID || '',
    process.env.NEXT_PUBLIC_GTM_AUTH,
    process.env.NEXT_PUBLIC_GTM_PREVIEW,
  ),
  buildGtmScript(
    process.env.NEXT_PUBLIC_GTM_GLOBAL_ID || '',
    process.env.NEXT_PUBLIC_GTM_GLOBAL_AUTH,
    process.env.NEXT_PUBLIC_GTM_GLOBAL_PREVIEW,
  ),
].filter((script) => script !== null);

export const consentScripts = gtmScripts;
